import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment.prod';
import { Persona } from '../model/Persona';
import { Variables } from '../enum/Variables';
import { EndPoint } from '../enum/EndPoint.enum';
import { interval, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ResponseApi } from '../model/ResponseApi';

@Injectable({
  providedIn: 'root'
})
export class ApiService  {

  private urlApi: string = environment.urlApi;

  // URL y token fijos del webhook externo para leer boletas
  private readonly URL_LEER_BOLETA = 'https://service.granjazul.com/webhook/leerboleta';
  private readonly TOKEN_LEER_BOLETA = 'Bearer 477275706f437265737461506f7274616c50726f766565646f726573454c434d46';

  public intervalTurno$ ;

  public recargar:number = 0;


  constructor(private http: HttpClient, private router: Router) {

    console.log('URL Apis: '+this.urlApi);

  }

  get personasesion():Persona {
    let payload = localStorage.getItem(Variables.PAYLOAD);
    return  Persona.instance(JSON.parse(""+payload))
  }

  get urlImagenLocal(): string {
    return '../../assets/img';
  }

  get tiempoDebounce() {
    return 700;
  }

  get isLogin() {
    let token = localStorage.getItem(Variables.TOKEN_LOCALSTORAGE);
    return (token && token.length > 0) ? true : false;
  }

  private get headers() {
    return {
      headers: { 'content-type': 'application/json' }
    }
  }

  /**
   * Headers para el endpoint propio de la app.
   * El token se obtiene de localStorage con la clave TOKEN_CAFEAPP_GRANJAZUL.
   */
  private get headersCafeApp() {
    const token = localStorage.getItem('TOKEN_CAFEAPP_GRANJAZUL') || '';
    return {
      headers: { 'token': token }
    };
  }

  private body(obj: any) {
    return obj;
  }

  mensajeError(error:any){
    return error['sqlMessage']||JSON.stringify(error)||error
  }

  detenerIntervalTurno(){
    try {
      console.log('Deteniendo timer...');
      clearInterval(this.intervalTurno$);
      this.intervalTurno$ = 0;
    } catch (error) {
      console.log(error)
    }
  }

  obtenerFechaActual():string {

    let fecha = new Date();
    let fechaFormateada: string = '';

    let dd = String(fecha.getDate()).padStart(2, '0');
    let mm = String(fecha.getMonth() + 1).padStart(2, '0');
    let yyyy = fecha.getFullYear();

    fechaFormateada = yyyy+'-'+mm+'-'+dd ;

    return fechaFormateada;
  }

  iniciarSesion(api: EndPoint, data: any) {
    let url = `${this.urlApi}/${api}/login`;
    return this.response(this.http.post(`${url}`, this.body(data), this.headers));
  }

  registrarse(api: EndPoint, data: any) {
    let url = `${this.urlApi}/${api}/registro`;
    this.logPeticion('registrarse', url, data);
    return this.response(this.http.post(`${url}`, this.body(data), this.headers));
  }

  cerrarSesion() {
    localStorage.removeItem(Variables.TOKEN_LOCALSTORAGE);
    localStorage.removeItem(Variables.PAYLOAD);
    this.router.navigateByUrl("/" + EndPoint.LOGIN);
  }

  post(api: string, data: any) {
    let url = `${this.urlApi}/${api}`;
    this.logPeticion('post', url, data);
    return this.response(this.http.post(url, this.body(data), this.headers));
  }

  buscarFiltro(api:string, data:any, estricto:string){
    let url;
    if(data === undefined){
      let url = `${this.urlApi}/${api}/ `;
      this.logPeticion('get', url);
      return this.response(this.http.get(url));
    } else {
      let url = (estricto==="N") ? `${this.urlApi}/${api}/filtro`: `${this.urlApi}/${api}/filtroestricto`;
      this.logPeticion('post', url, data);
      return this.response(this.http.post(url, this.body(data), this.headers));
    }
  }

  cargar(api: string, id: string | undefined) {
    let url;
    if (id) {
      url = `${this.urlApi}/${api}/${id}`;
    } else {
      url = `${this.urlApi}/${api}`;
    }
    this.logPeticion('cargar', url);
    return this.response(this.http.get(url));
  }

  eliminar(api: EndPoint, id: string | number) {
    let url = `${this.urlApi}/${api}/${id}`;
    this.logPeticion('eliminar', url, id);

    return this.response(this.http.delete(url));
  }

  // ---------------------------------------------------------------------------
  // BOLETAS
  // ---------------------------------------------------------------------------

  /**
   * Envía una imagen de boleta al webhook externo para extraer sus datos.
   * Usa token fijo (TOKEN_LEER_BOLETA). El body va como FormData con el campo "file".
   *
   * @param archivo - Objeto File con la imagen de la boleta (solo imágenes)
   * @returns Observable con los datos extraídos de la boleta
   */
  leerBoleta(archivo: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', archivo);

    return this.http.post(this.URL_LEER_BOLETA, formData, {
      headers: { 'authorization': this.TOKEN_LEER_BOLETA }
    });
  }

  /**
   * Sube los datos de una boleta ya procesada al backend propio de la app.
   * Usa el token almacenado en localStorage bajo la clave TOKEN_CAFEAPP_GRANJAZUL.
   *
   * @param data - Objeto con idpersona y todos los campos devueltos por leerBoleta()
   * @returns Observable con la respuesta del servidor
   */
  subirBoleta(data: {
    idpersona: number | string;
    Banco: string;
    ReferenciaBoleta: string;
    FechaBoleta: string;
    HoraBoleta: string;
    EstadoTransaccion: string;
    TipoOperacion: string;
    CuentaDebitoNombre: string;
    CuentaDebitoNumero: string;
    CuentaDebitoTipo: string;
    CuentaDepositoNombre: string;
    CuentaDepositoBanco: string;
    CuentaDepositoNumero: string;
    CuentaDepositoTipo: string;
    Moneda: string;
    Monto: number;
    TipoTransaccion: string;
    Descripcion: string;
    TextoBoleta: string;
  }): Observable<any> {
    const url = `${this.urlApi}/caja/subirboleta`;
    this.logPeticion('subirBoleta', url, data);
    return this.response(this.http.post(url, this.body(data), this.headersCafeApp));
  }

  /**
   * Obtiene el historial de boletas de una persona en un rango de fechas.
   * Usa el token del interceptor (TOKEN_LOCALSTORAGE).
   */
  obtenerBoletas(idpersona: number | string, fechainicio: string, fechafin: string): Observable<any> {
    const url = `${this.urlApi}/caja/boletas`;
    const data = { idpersona, fechainicio, fechafin };
    this.logPeticion('obtenerBoletas', url, data);
    return this.response(this.http.post(url, this.body(data), this.headers));
  }

  // ---------------------------------------------------------------------------

  log(ubicacion: string, dato: any) {
    //console.log(' =>> Ubicacion', ubicacion, ' =>> dato', dato);
  }


  private logPeticion(metodo: string, url: string, datos?: any) {
    //console.log('=>>', metodo, ' =>> Url', url, ' =>> datos', datos);
  }

  //Creo un objeto de tipo ResponseApi con la peticion
  private response(solicitud: Observable<any>) {
    return solicitud.pipe(
      map(resp => ResponseApi.getInstance(resp))
    );
  }


  /**
 * Headers con el token del interceptor (TOKEN_LOCALSTORAGE).
 * Usado para endpoints que requieren autenticación de sesión.
 */
private get headersConToken() {
  const token = localStorage.getItem(Variables.TOKEN_LOCALSTORAGE) || '';
  return {
    headers: {
      'content-type': 'application/json',
      'token': token
    }
  };
}


  /**
 * Búsqueda con filtro usando token de sesión (TOKEN_LOCALSTORAGE).
 * Equivale a: POST {{apiurl}}/{api}/filtro  con header token y body JSON.
 *
 * @param api   - Segmento de la URL, ej: 'persona'
 * @param data  - Objeto con los campos del filtro, ej: { nombre: 'texto' }
 */
buscarFiltroConToken(api: string, data: any) {
  const url = `${this.urlApi}/${api}/filtro`;
  this.logPeticion('buscarFiltroConToken', url, data);
  return this.response(this.http.post(url, this.body(data), this.headersConToken));
}

/**
 * POST genérico usando token de sesión (TOKEN_LOCALSTORAGE).
 * Equivale a: POST {{apiurl}}/{api}  con header token y body JSON.
 *
 * @param api   - Ruta completa del endpoint, ej: 'caja/transferencia'
 * @param data  - Objeto con los campos del body
 */
postConToken(api: string, data: any) {
  const url = `${this.urlApi}/${api}`;
  this.logPeticion('postConToken', url, data);
  return this.response(this.http.post(url, this.body(data), this.headersConToken));
}
}